export default __webpack_public_path__ + "static/media/italian-wood-slider.35915231.jpg";